<template>
  <div class="param px" :class="{ cn: isCN }">
    <div class="title" v-if="false">
      {{ $t("mouse.paramSettings") }}
    </div>
    <div class="tip" style="color: #fff;">
      {{ $t("mouse.debounceTip") }}
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.debounce") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.debounceTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      {{ $t("slow") }}
      <a-slider
        class="slider"
        v-model="unifiedDebounceGear"
        :min="0"
        :max="6"
        :tooltipVisible="false"
        @afterChange="onUnifiedDebounceAfterChange"
        style="margin-left: 0.3rem;"
      />
      {{ $t("fast") }}
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.reportRate") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.reportRateTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group :value="reportRate" @change="onReportRateChange" class="radio-group">
        <a-radio class="radio" :value="125">125</a-radio>
        <a-radio class="radio" :value="250">250</a-radio>
        <a-radio class="radio" :value="500">500</a-radio>
        <a-radio class="radio" :value="1000">1000</a-radio>
        <a-radio class="radio" :value="2000">2000</a-radio>
        <a-radio class="radio" :value="4000">4000</a-radio>
        <a-radio class="radio" :value="8000">8000</a-radio>
      </a-radio-group>
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.liftCutOff") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.liftCutOffTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group :value="LOD" @change="onLODChange" class="radio-group">
        <a-radio class="radio" :value="0">{{ $t("mouse.low") }}</a-radio>
        <a-radio class="radio" :value="1">{{ $t("mouse.middle") }}</a-radio>
        <a-radio class="radio" :value="2">{{ $t("mouse.high") }}</a-radio>
      </a-radio-group>
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.motionSync") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.motionSyncTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group :value="MotionSync" @change="onMotionSyncChange" class="radio-group">
        <a-radio class="radio" :value="1">{{ $t("mouse.on") }}</a-radio>
        <a-radio class="radio" :value="0">{{ $t("mouse.off") }}</a-radio>
      </a-radio-group>
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.angleSnap") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.angleSnapTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group :value="AngleSnapping" @change="onAngleSnappingChange" class="radio-group">
        <a-radio class="radio" :value="1">{{ $t("mouse.on") }}</a-radio>
        <a-radio class="radio" :value="0">{{ $t("mouse.off") }}</a-radio>
      </a-radio-group>
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.rippleCorrection") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.rippleCorrectionTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group :value="RippleCtrl" @change="onRippleCtrlChange" class="radio-group">
        <a-radio class="radio" :value="1">{{ $t("mouse.on") }}</a-radio>
        <a-radio class="radio" :value="0">{{ $t("mouse.off") }}</a-radio>
      </a-radio-group>
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.sleepOneTimeBT") }}{{ $t("mouse.sleepTimeSuffix") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.sleepTimeTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group :value="sleepTimeBT" class="radio-group" @change="onSleepTimeBTChange">
        <a-radio class="radio" :value="15">15s</a-radio>
        <a-radio class="radio" :value="30">30s</a-radio>
        <a-radio class="radio" :value="60">1min</a-radio>
        <a-radio class="radio" :value="600">10min</a-radio>
        <a-radio class="radio" :value="1800">30min</a-radio>
        <a-radio class="radio" :value="3600">1h</a-radio>
        <a-radio class="radio" :value="-1">{{ $t("mouse.never") }}</a-radio>
      </a-radio-group>
      <md-field class="num" v-show="sleepTimeBT != -1">
        <md-input
          @blur="onSleepTimeBTInputBlur"
          @keypress.enter="onSleepTimeBTInputBlur"
          :value="sleepTimeBT"
          class="number-input"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');"
        ></md-input>
        <span class="md-suffix">s</span>
      </md-field>
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.sleepOneTime24G") }}{{ $t("mouse.sleepTimeSuffix") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.sleepTimeTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group :value="sleepTime24G" class="radio-group" @change="onSleepTime24GChange">
        <a-radio class="radio" :value="15">15s</a-radio>
        <a-radio class="radio" :value="30">30s</a-radio>
        <a-radio class="radio" :value="60">1min</a-radio>
        <a-radio class="radio" :value="600">10min</a-radio>
        <a-radio class="radio" :value="1800">30min</a-radio>
        <a-radio class="radio" :value="3600">1h</a-radio>
        <a-radio class="radio" :value="-1">{{ $t("mouse.never") }}</a-radio>
      </a-radio-group>
      <md-field class="num" v-show="sleepTime24G != -1">
        <md-input
          @blur="onSleepTime24GInputBlur"
          @keypress.enter="onSleepTime24GInputBlur"
          :value="sleepTime24G"
          class="number-input"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');"
        ></md-input>
        <span class="md-suffix">s</span>
      </md-field>
    </div>
    <div class="param-item" >
      <div class="name">
        {{ $t("mouse.fpsMode") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.fpsModeTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group :value="AM35FPStatus" @change="onAM35FPStatusChange" class="radio-group">
        <a-radio class="radio" :value="1">{{ $t("mouse.on") }}</a-radio>
        <a-radio class="radio" :value="0">{{ $t("mouse.off") }}</a-radio>
      </a-radio-group>
    </div>
    <div v-if="showRotateAngleEntry" class="param-item param-item-rotate-angle">
      <div class="name">
        {{ $t("mouse.rotateAngle") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question" v-html="$t('mouse.rotateAngleTooltip')"></div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <md-button class="button" @click="openRotateAngleModal">
        {{ $t("mouse.openRotateAngleSetting") }}
      </md-button>
    </div>
    <rotation-modal
      v-if="showRotateAngleEntry"
      :visible.sync="rotateAngleVisible"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";
import RotationModal from "./RotationModal";

export default {
  name: "CMouseAm35Param",
  components: {
    "sketch-picker": vueColor.Sketch,
    RotationModal,
  },
  data() {
    return {
      rotateAngleVisible: false,
      // 蓝牙消抖档位映射（所有回报率通用）
      btDebounceGears: [10, 8, 6, 4, 3, 2, 0],
      
      // 不同回报率下的有线消抖映射表（档位0-6对应的实际下发值，从慢到快）
      wireDebounceGearsMap: {
        125: [10, 8, 6, 4, 3, 2, 0],        // 125Hz
        250: [10, 8, 6, 4, 3, 2, 0],        // 250Hz
        500: [10, 8, 6, 4, 3, 2, 0],        // 500Hz
        1000: [10, 8, 6, 4, 3, 2, 0],       // 1K
        2000: [20, 16, 12, 8, 4, 2, 0],    // 2K
        4000: [39, 31, 23, 15, 7, 3, 0],   // 4K
        8000: [79, 63, 47, 31, 15, 7, 0],  // 8K
      },
      
      // 不同回报率下的2.4G消抖映射表（档位0-6对应的实际下发值，从慢到快）
      rf24gDebounceGearsMap: {
        125: [10, 8, 6, 4, 3, 2, 0],        // 125Hz
        250: [10, 8, 6, 4, 3, 2, 0],        // 250Hz
        500: [10, 8, 6, 4, 3, 2, 0],        // 500Hz
        1000: [10, 8, 6, 4, 3, 2, 0],       // 1K
        2000: [20, 16, 12, 8, 4, 2, 0],     // 2K
        4000: [39, 31, 23, 15, 7, 3, 0],   // 4K
        8000: [79, 63, 47, 31, 15, 7, 0],  // 8K
      },
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
    }),
    ...mapState("mouseAM35", {
      reportRate: "reportRate",
      wireDebounce: "wireDebounce",
      rf24gDebounce: "rf24gDebounce",
      btDebounce: "btDebounce",
      MotionSync: "MotionSync",
      LOD: "LOD",
      AngleSnapping: "AngleSnapping",
      RippleCtrl: "RippleCtrl",
      AM35FPStatus: "AM35FPStatus",
      AM35rotateAngleSwitch: "AM35rotateAngleSwitch",
      setAM35rotateAngle: "setAM35rotateAngle",
      sleepTimeBT: "sleepTimeBT",
      sleepTime24G: "sleepTime24G",
    }),
    showRotateAngleEntry() {
      return !(
        this.AM35rotateAngleSwitch == null &&
        this.setAM35rotateAngle == null
      );
    },
    // 统一档位计算属性
    unifiedDebounceGear: {
      get() {
        // 根据当前回报率获取对应的有线消抖映射表
        const wireGears = this.wireDebounceGearsMap[this.reportRate] || this.wireDebounceGearsMap[1000];
        // 使用 wireDebounce 作为档位参考,若不在映射表中则找最接近的档位
        let index = wireGears.findIndex(val => val === this.wireDebounce);
        if (index < 0) {
          // 找最接近的档位
          const diffs = wireGears.map(v => Math.abs(v - this.wireDebounce));
          index = diffs.indexOf(Math.min(...diffs));
        }
        return index >= 0 ? index : 0;
      },
      set(gear) {
        // 根据当前回报率和档位获取对应的消抖值
        const wireGears = this.wireDebounceGearsMap[this.reportRate] || this.wireDebounceGearsMap[1000];
        const rf24gGears = this.rf24gDebounceGearsMap[this.reportRate] || this.rf24gDebounceGearsMap[1000];
        
        const wireValue = wireGears[gear] !== undefined ? wireGears[gear] : 0;
        const rf24gValue = rf24gGears[gear] !== undefined ? rf24gGears[gear] : 0;
        const btValue = this.btDebounceGears[gear] || 0;
        
        this.dispatchDebounceTriple({
          wireDebounce: wireValue,
          rf24gDebounce: rf24gValue,
          btDebounce: btValue
        });
      }
    },
  },
  methods: {
    // 根据当前回报率获取有线消抖映射表
    getWireDebounceGears() {
      return this.wireDebounceGearsMap[this.reportRate] || this.wireDebounceGearsMap[1000];
    },
    
    // 根据当前回报率获取2.4G消抖映射表
    getRf24gDebounceGears() {
      return this.rf24gDebounceGearsMap[this.reportRate] || this.rf24gDebounceGearsMap[1000];
    },
    
    // 根据当前回报率和档位获取有线消抖值
    getWireDebounceValue(gear) {
      const gears = this.getWireDebounceGears();
      return gears[gear] !== undefined ? gears[gear] : 0;
    },
    
    // 根据当前回报率和档位获取2.4G消抖值
    getRf24gDebounceValue(gear) {
      const gears = this.getRf24gDebounceGears();
      return gears[gear] !== undefined ? gears[gear] : 0;
    },
    
    // 三路去抖变更：统一派发到设备与store
    dispatchDebounceTriple(partial) {
      const payload = {
        wireDebounce: this.wireDebounce,
        rf24gDebounce: this.rf24gDebounce,
        btDebounce: this.btDebounce,
        ...partial,
      };
      this.$store.dispatch("mouseAM35/setDebounce", payload);
      return payload;
    },

    // 统一消抖档位变更后回调
    onUnifiedDebounceAfterChange(gear) {
      const wireGears = this.wireDebounceGearsMap[this.reportRate] || this.wireDebounceGearsMap[1000];
      const rf24gGears = this.rf24gDebounceGearsMap[this.reportRate] || this.rf24gDebounceGearsMap[1000];
      
      const wireValue = wireGears[gear] !== undefined ? wireGears[gear] : 0;
      const rf24gValue = rf24gGears[gear] !== undefined ? rf24gGears[gear] : 0;
      const btValue = this.btDebounceGears[gear] || 0;
      
      const payload = this.dispatchDebounceTriple({
        wireDebounce: wireValue,
        rf24gDebounce: rf24gValue,
        btDebounce: btValue
      });
      this.$store.dispatch("loader/setAM35Debounce", payload);
    },
    
    onReportRateChange(e) {
      const value = e.target.value;
      
      // 先获取当前档位（基于旧回报率）
      const currentGear = this.unifiedDebounceGear;
      
      // 更新回报率到 store（这会触发 computed 重新计算）
      this.$store.dispatch("mouseAM35/setReportRate", value);
      
      // 根据新回报率和当前档位计算新的消抖值
      const wireGears = this.wireDebounceGearsMap[value] || this.wireDebounceGearsMap[1000];
      const rf24gGears = this.rf24gDebounceGearsMap[value] || this.rf24gDebounceGearsMap[1000];
      
      const wireValue = wireGears[currentGear] !== undefined ? wireGears[currentGear] : 0;
      const rf24gValue = rf24gGears[currentGear] !== undefined ? rf24gGears[currentGear] : 0;
      const btValue = this.btDebounceGears[currentGear] || 0;
      
      // 先更新 store 中的消抖值（这样 getter 能正确计算档位）
      const payload = this.dispatchDebounceTriple({
        wireDebounce: wireValue,
        rf24gDebounce: rf24gValue,
        btDebounce: btValue
      });
      
      // 再下发到设备
      this.$store.dispatch("loader/setAM35reportRate", {
        reportRate: value,
      });
      this.$store.dispatch("loader/setAM35Debounce", payload);
    },
    onLODChange(e) {
      const value = e.target.value;
      this.$store.dispatch("loader/setAM35LOD", {
        LOD: value,
      });
      this.$store.dispatch("mouseAM35/setLOD", value);
    },
    onMotionSyncChange(e) {
      const value = e.target.value;
      this.$store.dispatch("loader/setAM35MotionSync", {
        MotionSync: value,
      });
      this.$store.dispatch("mouseAM35/setMotionSync", value);
    },
    onAngleSnappingChange(e) {
      const value = e.target.value;
      this.$store.dispatch("loader/setAM35AngleSnapping", {
        AngleSnapping: value,
      });
      this.$store.dispatch("mouseAM35/setAngleSnapping", value);
    },
    onRippleCtrlChange(e) {
      const value = e.target.value;
      this.$store.dispatch("loader/setAM35RippleCtrl", {
        RippleCtrl: value,
      });
      this.$store.dispatch("mouseAM35/setRippleCtrl", value);
    },
    onAM35FPStatusChange(e) {
      const value = e.target.value;
      // 调用协议方法
      this.$store.dispatch("loader/setAM35FPS", {
        setAM35FPS: value,
      });
      // 更新 store
      this.$store.dispatch("mouseAM35/setAM35FPStatus", value);
    },
    onSleepTime24GChange(e) {
      const value = Number(e.target.value);
      this.$store.dispatch("loader/setSleepTime", {
        sleepTimeBT: this.sleepTimeBT,
        sleepTime24G: value,
      });
      this.$store.dispatch("mouseAM35/setSleepTime24G", value);
    },
    onSleepTime24GInputBlur(e) {
      let value = Number(e.target.value);
      // 失焦时才进行范围限制
      value = Math.max(15, Math.min(65535, value || 15));
      this.$store.dispatch("loader/setSleepTime", {
        sleepTimeBT: this.sleepTimeBT,
        sleepTime24G: value,
      });
      this.$store.dispatch("mouseAM35/setSleepTime24G", value);
    },
    onSleepTimeBTChange(e) {
      const value = Number(e.target.value);
      this.$store.dispatch("loader/setSleepTime", {
        sleepTimeBT: value,
        sleepTime24G: this.sleepTime24G,
      });
      this.$store.dispatch("mouseAM35/setSleepTimeBT", value);
    },
    openRotateAngleModal() {
      if (!this.showRotateAngleEntry) {
        return;
      }
      this.rotateAngleVisible = true;
    },
    onSleepTimeBTInputBlur(e) {
      let value = Number(e.target.value);
      // 失焦时才进行范围限制
      value = Math.max(15, Math.min(65535, value || 15));
      this.$store.dispatch("loader/setSleepTime", {
        sleepTimeBT: value,
        sleepTime24G: this.sleepTime24G,
      });
      this.$store.dispatch("mouseAM35/setSleepTimeBT", value);
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.param {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    width: 1200px;
    text-align: left;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .param-item {
    @include flex-center;
    width: 1200px;
    justify-content: flex-start;
    padding: 15px 0;
    font-size: 20px;

    .name {
      @include flex-center;
      font-size: 20px;
      width: 200px;
      margin-right: 20px;
      justify-content: flex-start;

      .name-tip {
        color: $primary-color;
        margin-left: 5px;
        cursor: pointer;
      }
    }

    .slider {
      width: 300px;
      margin-right: 40px;
      margin-left: 93px;
    }

    .radio-group {
      @include flex-center;

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
      }
    }

    .color {
      width: 25px;
      height: 25px;
      border: 1px solid $primary-color;
      margin-left: 30px;

      & + .num {
        margin-left: 10px;
      }
    }

    .num,
    .tip {
      width: 80px;
      font-size: 20px;
      margin: 0 40px 0 0;
      padding: 0;
      white-space: nowrap;

      .number-input {
        width: 100%;
        text-align: center;
      }
    }

    .tip {
      width: auto;
      font-size: 16px;
      color: #cccccc;
    }

    &.param-item-rotate-angle {
      .button {
        margin-left: 0;
      }
    }
  }

  .button {
    @include button;
    width: 120px;
    height: 34px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;

    &:hover {
      color: #ffffff;
    }
  }

  &.cn .param-item .slider {
    margin-left: 50px;
  }
}
</style>

<style lang="scss">
// Popover 内容样式（非 scoped，因为 popover 渲染在 body 下）
// 使用更具体的选择器避免影响其他组件
.param + .ant-popover,
.ant-popover-placement-right {
  .ant-popover-inner-content {
    .name-question {
      width: 320px;
      text-align: left;
      font-size: 16px !important;
      line-height: 1.6;
      word-wrap: break-word;
      word-break: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
    }
  }
}

.param {
  .slider {
    padding: 4px 0;
    .ant-slider-rail {
      height: 4px;
      background-color: #717171 !important;
    }

    .ant-slider-track {
      height: 4px;
      background-color: $primary-color !important;
    }

    .ant-slider-dot-active {
      border-color: transparent;
    }

    .ant-slider-step {
      height: 4px;
    }

    .ant-slider-handle {
      width: 20px;
      height: 20px;
      margin-top: -7px;
      background-color: $primary-color !important;
      border: 0;
      box-shadow: none;
    }
  }

  .ant-radio-group .radio {
    background: #101010;
    border-radius: 5px;
    padding: 0 2px 0 12px;
    margin-right: 12px;

    .ant-radio {
      margin-right: 5px;

      .ant-radio-inner {
        border-color: $primary-color;

        &::after {
          background-color: $primary-color;
        }
      }
    }

    &.ant-radio-wrapper-checked,
    &:hover {
      color: $primary-color;
    }
  }

  .md-switch.md-theme-default.md-checked.md-primary .md-switch-container {
    background-color: rgb(0, 200, 0);
  }

  .color-slider {
    .vc-slider-hue-warp {
      height: 10px;

      .vc-hue-pointer {
        margin-top: -5px;
      }
    }
  }
}
.ant-tooltip-inner {
  color: #000000;

  .vc-editable-input input {
    text-align: center;
  }
}
</style>
